import { useEffect, useState } from "react";
import { fetchLeadershipPage } from "../../services/api";
import { BlocksRenderer } from '@strapi/blocks-react-renderer';

export default function InsideIndustry({lang}) {
  const [industryList, setIndustryList] = useState([]);
   const [pageData, setPageData] = useState(null);

useEffect(() => {
  setPageData(null);
  setIndustryList([]);

  const loadData = async () => {
    const enData = await fetchLeadershipPage("en");
    let source = enData;

    if (lang !== "en") {
      const localData = await fetchLeadershipPage(lang);

      const hasLocalData =
        localData &&
        !Array.isArray(localData) &&
        Object.keys(localData).length > 0;

      source = hasLocalData ? localData : enData;
    }

    if (source) setPageData(source);
    if (source?.Industry_list?.length) {
      setIndustryList(source.Industry_list);
    } else if (enData?.Industry_list?.length) {
      // Final fallback to English list
      setIndustryList(enData.Industry_list);
    }
  };

  loadData();
}, [lang]);

  return (
    <div className="padding-x-40 padding-y-80" style={{ background: "rgba(188, 226, 245, 1)" }}>
          <div className="section-name-wrapper mb-160 ">
            <div className="section-name-dot"></div>
            <h6 className="section-name" >
 {pageData?.Inside_Industry_Section_Name}
            </h6>
          </div>
      {industryList.map((report, index) => (
        <div style={{borderTop: "1px solid rgba(25, 175, 225, 1)",}}
          key={report.id}
          className=" mt-[40px] pt-[20px]"
        >
   {/* Mobile & Tablet: number + arrow on same row */}
          <div className="flex items-start justify-between xl:hidden mb-2">
                    <a
  href={report.List_url}   target="_blank"
  rel="noopener noreferrer"
  className="flex items-start justify-between xl:hidden mb-2 w-full"
>
            <span className="serial-number">
              {String(index + 1).padStart(2, "0")}
            </span>
            <span>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 37 36" fill="none">
                <path d="M17.8308 1.41426L34.0415 17.625M34.0415 17.625L17.8308 33.8357M34.0415 17.625H0" stroke="#004098" strokeWidth="4"/>
              </svg>
            </span>
            </a>
          </div>
            {/* Mobile & Tablet: title + description stacked */}
          <div className="flex flex-col xl:hidden">
            <a
  href={report.List_url}   target="_blank"
  rel="noopener noreferrer"
  className="flex flex-col xl:hidden w-full"
>
            <h3 className="inside-industry-list-title whitespace-pre-line mb-3">
              <BlocksRenderer content={report.List_Title} />
            </h3>
            <div className="text-dark-blue-color font-medium">
              <p>{report.List_Description}</p>
              <a
                href={report.List_url}   target="_blank"
  rel="noopener noreferrer"
                className="text-accent-blue underline font-medium"
              >
                {report.List_link}
              </a>
            </div>
            </a>
            </div>
                    {/* Desktop: original horizontal layout */}
          <div className="hidden xl:flex items-start">
<a
  href={report.List_url}   target="_blank"
  rel="noopener noreferrer"
  className="hidden xl:flex items-start w-full"
>
          {/* Number */}
          <span className="serial-number w-[10%]">
            {String(index + 1).padStart(2, "0")}
          </span>

          {/* Title */}
        <h3 className="inside-industry-list-title w-[40%] whitespace-pre-line">
  <BlocksRenderer content={report.List_Title} />
</h3>

          {/* Description */}
          <div className="w-[40%] text-dark-blue-color font-medium pl-5" style={{fontSize:'16px'}}>
            <p>{report.List_Description}</p>
            <a
              href={report.List_url}   target="_blank"
  rel="noopener noreferrer"
              className="text-accent-blue underline font-medium"
            >
              {report.List_link}
            </a>
          </div>

          {/* Arrow */}
          <span className=" ml-auto">
            {/* <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 37 36" fill="none">
<path d="M17.8308 1.41426L34.0415 17.625M34.0415 17.625L17.8308 33.8357M34.0415 17.625H0" stroke="#004098" stroke-width="4"/>
</svg> */}
<svg xmlns="http://www.w3.org/2000/svg" width="38" height="36" viewBox="0 0 38 36">
<path d="M 18 0 L 16 2 L 16 3 L 27 14 L 26 15 L 0 15 L 0 19 L 27 19 L 28 20 L 16 32 L 19 35 L 36 18 L 36 17 L 19 0 Z" fill="#004098"/>
</svg>
</span>
</a>
        </div>
        </div>
      ))}
    </div>
  );
}